import { createSelector } from 'reselect'

export const getActivity = state => state.get('persist').activity

export const getActivityId = createSelector(getActivity, activity => activity.get('id'))

export const getActivityUserActivityId = createSelector(getActivity, activity => activity.get('userActivityId'))

export const getActivityDescription = createSelector(getActivity, activity => activity.get('description'))

export const getActivityName = createSelector(getActivity, activity => activity.get('name'))

export const getActivityDay = createSelector(getActivity, activity => activity.get('day'))

export const getActivityImage = createSelector(getActivity, activity => activity.get('image'))

export const getActivityProQuote = createSelector(getActivity, activity => activity.get('proQuote'))

export const getActivityProQuoteAuthor = createSelector(getActivity, activity => activity.get('proQuoteAuthor'))

export const getActivityRating = createSelector(getActivity, activity => activity.get('rating'))

export const getActivityRatingPending = createSelector(getActivity, activity => activity.get('saveRatingPending'))

export const getActivityQuestion = createSelector(getActivity, activity => activity.get('question'))

export const getIsFavorite = createSelector(getActivity, activity => activity.get('isFavorite'))

export const getIsRated = createSelector(getActivity, activity => activity.get('isRated'))

export const getHasStory = createSelector(getActivity, activity => activity.get('hasStory'))

export const getActionType = createSelector(getActivity, activity => activity.get('actionType'))

export const activityVideoId = createSelector(getActivity, activity => activity.get('videoId'))

export const activityVideoThumbnail = createSelector(getActivity, activity => activity.get('videoThumbnail'))

export const activityIsRepeating = createSelector(getActivity, activity => activity.get('isRepeating'))
